import React, { useState, useEffect } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { SettingOutlined } from "@ant-design/icons";
import {
    Button,
    Table,
    Pagination,
    Space,
    Tooltip,
    Input,
    Segmented,
} from "antd";
import {
    EditOutlined,
    EyeOutlined,
    LockOutlined,
    UnlockOutlined,
    BulbOutlined,
} from "@ant-design/icons";
import { history } from "../_helpers/history";
import styles from "./styles/PresetManager.module.css";
// import { useItemsFine } from "../_actions/app/items";
import { useItemsFine, useUpdateItemMutation } from "../actions/app/items";
import LoadingBox from "../common/LoadingBox";
import PresetSuggestions from "./PresetSuggestions";
import log from "cslog";

const per_page = 50;

const FILTERS = {
    All: "",
    Ready: "&filter[enabled]=true",
    Draft: "&filter[enabled]=false",
};

const FILTERS_TYPE = {
    Designs: "&filter[type][_eq]=singlepage",
    Documents: "&filter[type][_eq]=document",
};
function PresetManager() {
    const [total, setTotal] = useState(1);
    const [page_no, setPageNo] = useState(1);
    const [num_page, setNumPage] = useState(1);
    const [sort, setSort] = useState("date_created");
    const [allRecords, setAllRecords] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [filters, setFilters] = useState("All");
    const [filter_string, setFilterString] = useState("");
    const [selected_type, setSelectedType] = useState("Designs");
    const [type_filter_string, setTypeFilterString] = useState(
        FILTERS_TYPE["Designs"]
    );

    const { isSuccess, isLoading, data } = useItemsFine(
        "qdb_creation_schema",
        `fields=*,id,block_id,name,description,inputs,true_schema,enabled&sort=${sort}${`${filter_string}${type_filter_string}${
            searchQuery
                ? `&filter[_or][0][name][_contains]=${searchQuery}&filter[_or][1][block_id][_contains]=${searchQuery}`
                : ""
        }`}&limit=${per_page}&offset=${per_page * (page_no - 1)}&meta=*`,
        true,
        false,
        true,
        true
    );

    const [counts, setCounts] = useState({});

    const {
        isSuccess: successTemp,
        isLoading: loadingTemp,
        data: dataTemp,
    } = useItemsFine(
        "qdb_creation_template",
        `fields=id,used_schemas.qdb_creation_schema_id&limit=-1`,
        true
    );

    const mutation_update = useUpdateItemMutation();

    useEffect(() => {
        if (successTemp) {
            const out = {};
            log.d(dataTemp, "dataTemp in PMM");
            dataTemp?.forEach((item) => {
                item?.used_schemas?.forEach((schema) => {
                    const schema_id = schema?.qdb_creation_schema_id;
                    if (out[schema_id]) {
                        out[schema_id] += 1;
                    } else {
                        out[schema_id] = 1;
                    }
                });
            });
            log.d(out, "out in PMM");
            setCounts(out);
        }
    }, [successTemp, loadingTemp, dataTemp]);

    useEffect(() => {
        if (filters) {
            setFilterString(FILTERS[filters]);
        }
    }, [filters]);

    //   Function to toggle enabled state
    const toggleEnabled = (record) => {
        mutation_update.mutate({
            collection: "qdb_creation_schema",
            id: record.id,

            data: { enabled: !record.enabled },
        });
    };
    const item = { id: 1 };

    useEffect(() => {
        setPageNo(1);
    }, [searchQuery]);

    useEffect(() => {
        if (isSuccess && data) {
            const totalCount = data?.meta?.filter_count;
            console.log("Total records:", totalCount);
            setTotal(totalCount);
            setNumPage(Math.ceil(totalCount / per_page));
            setAllRecords(data?.data);
        }
    }, [isSuccess, data]);

    // useEffect(() => {
    //     if (isSuccess && data) {
    //         setPaginatedData(data?.data);
    //     }
    // }, [isSuccess, data]);

    useEffect(() => {
        if (isSuccess && data) {
            const out = data?.data?.map((item) => {
                return {
                    ...item,
                    template_count: counts[item.id] || 0,
                };
            });
            log.d(out, "PMM out in useEffect");
            setPaginatedData(out);
        }
    }, [isSuccess, data, counts]);

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Preset Manager"
                    icon={<SettingOutlined />}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <Input.Search
                            placeholder="Search presets by name or block id"
                            allowClear
                            onSearch={(value) => setSearchQuery(value)}
                            style={{ width: 250 }}
                        />
                        <Button
                            onClick={() => {
                                history.push(`/settings/presets/create`, {
                                    from: history.location.pathname,
                                });
                            }}
                        >
                            Create New
                        </Button>
                    </div>
                </SectionHeader>
            }
        >
            <div className={styles.wrapper}>
                <PresetFilters
                    value={filters}
                    onChange={setFilters}
                    selected_type={selected_type}
                    onTypeChange={(new_type) => {
                        setSelectedType(new_type);
                        setTypeFilterString(FILTERS_TYPE[new_type]);
                    }}
                />
                {isLoading && <LoadingBox />}
                {isSuccess && (
                    <Table
                        size="small"
                        locale={{ emptyText: "no preset found" }}
                        columns={[
                            {
                                title: "Block ID",
                                dataIndex: "block_id",
                                key: "block_id",
                                sorter: true,
                            },
                            {
                                title: "Name",
                                dataIndex: "name",
                                key: "name",
                                sorter: true,
                            },
                            {
                                title: "Description",
                                dataIndex: "description",
                                key: "description",
                                sorter: true,
                            },
                            {
                                title: "Enabled",
                                dataIndex: "enabled",
                                key: "name",
                                sorter: true,
                                render: (enabled) => (
                                    <span>{enabled ? "🟢" : "🟨"}</span>
                                ),
                            },
                            {
                                title: "Template Count",
                                dataIndex: "template_count",
                                key: "template_count",
                                sorter: (a, b) => {
                                    return a.template_count - b.template_count;
                                },
                                // render: (item, record) => {
                                //     return <span>{counts[record.id]}</span>;
                                // },
                            },
                            {
                                title: "Actions",
                                dataIndex: "actions",
                                key: "actions",
                                render: (item, record) => {
                                    return (
                                        <div className={styles.flex_h_center}>
                                            <Button
                                                // type="primary"
                                                onClick={() => {
                                                    history.push(
                                                        `/settings/presets/${record.id}/edit`,
                                                        {
                                                            from: history
                                                                .location
                                                                .pathname,
                                                        }
                                                    );
                                                }}
                                                disabled={record.locked}
                                                icon={<EditOutlined />}
                                            ></Button>
                                            <PresetSuggestions
                                                record={record}
                                                trigger={
                                                    <Button
                                                        icon={<BulbOutlined />}
                                                    ></Button>
                                                }
                                                filter_prefix="filter[presets][qdb_creation_schema_id][_eq]"
                                                makePayload={(text) => {
                                                    return {
                                                        label: text,
                                                        text: text.toLowerCase(),
                                                        platforms: [
                                                            "facebook",
                                                            "instagram",
                                                        ],
                                                        presets: [
                                                            {
                                                                qdb_creation_schema_id:
                                                                    record?.id,
                                                            },
                                                        ],
                                                        value: {
                                                            type: "preset",
                                                            data: {
                                                                preset: record?.block_id,
                                                                preset_id:
                                                                    record?.id,
                                                            },
                                                        },
                                                    };
                                                }}
                                            />
                                            <Button
                                                icon={<EyeOutlined />}
                                                onClick={() => {
                                                    history.push(
                                                        `/design-admin/templates-manager/${record.id}`,
                                                        {
                                                            from: history
                                                                .location
                                                                .pathname,
                                                        }
                                                    );
                                                }}
                                            ></Button>
                                            <Button
                                                // type="primary"
                                                onClick={() =>
                                                    toggleEnabled(record)
                                                }
                                                loading={
                                                    mutation_update.isLoading &&
                                                    mutation_update.variables
                                                        ?.id === record.id
                                                }
                                            >
                                                {record.enabled
                                                    ? "Disable"
                                                    : "Enable"}
                                            </Button>
                                        </div>
                                    );
                                },
                            },
                        ]}
                        rowKey="block_id"
                        bordered={true}
                        dataSource={paginatedData}
                        pagination={false}
                        onChange={(pagination, filter, sorter) => {
                            console.log(sorter);
                            if (sorter.field !== "template_count") {
                                if (sorter?.field && sorter?.order) {
                                    setSort(
                                        `${
                                            sorter.order === "ascend" ? "-" : ""
                                        }${sorter.field}`
                                    );
                                }
                            }
                        }}
                    />
                )}
                <div style={{ height: 20 }}></div>
                {isSuccess && total > per_page && (
                    <Pagination
                        current={page_no}
                        onChange={(new_page_no) => setPageNo(new_page_no)}
                        total={total}
                        pageSize={per_page}
                        showTitle={false}
                        showSizeChanger={false}
                        showQuickJumper={true}
                    />
                )}
            </div>
        </QurealSection>
    );
}

export default PresetManager;

function PresetFilters({ value, onChange, selected_type, onTypeChange }) {
    return (
        <div
            style={{
                paddingBottom: "15px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
            }}
        >
            <Segmented
                options={Object.keys(FILTERS)}
                value={value}
                onChange={(value) => {
                    onChange(value);
                }}
            />

            <Segmented
                options={Object.keys(FILTERS_TYPE)}
                value={selected_type}
                onChange={(value) => {
                    onTypeChange(value);
                }}
            />
        </div>
    );
}
